import React from "react";
import useClx from "../../hooks/use-clx";
import clxs from "./luma-tag.module.css";
import lumaTagIcon from "../../assets/icons/luma-tag.svg";
import Tooltip from "../ToolTip";

interface LumaTagProps {
    className?: string;
}
function LumaTag (props: LumaTagProps) {
    const {className} = props;
    const ccx = useClx(clxs.lumaTag, className);

    const lumaTooltipContent = (
        <div className={clxs.lumaTooltipContent}>
            <div>
            Your introduction to the world of Lohono. Luma brings together luxury villas, intuitive hospitality, and thoughtfully created community spaces - all at an easier price point.
            </div>
        </div>
    );

    return (
        <div className={ccx}>
            <div className={clxs.tagIcon}>
              <img 
                src={lumaTagIcon} 
                alt="icon" 
                className={clxs.tagIcon} 
              />
            </div>
            <span className={clxs.lumaTooltipContainer}>
              <Tooltip 
                content={lumaTooltipContent}
                showCloseIcon={false}
                isRight={true}
              />
            </span>
        </div>
    );
}

export default LumaTag;